import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './icons/Icon';
import Tooltip from './Tooltip';
import './AppNav.css';
import { getTodayDateString } from '../utils/dateUtils';

interface AppNavProps {
  activeItem?: 'todo' | 'stock';
}

const AppNav: React.FC<AppNavProps> = ({ activeItem = 'todo' }) => {
  const navigate = useNavigate();
  const [hovered, setHovered] = React.useState<null | 'todo' | 'stock'>(null);
  const goTodo = () => {
    const today = getTodayDateString();
    navigate(`/${today}/`);
  };
  const goStock = () => {
    navigate('/stock/category/uncategorized/');
  };
  return (
    <nav className="app-nav">
      <button
        className={`app-nav-button ${activeItem === 'todo' ? 'active' : ''}`}
        aria-label="TODO リスト"
        onClick={goTodo}
        onMouseEnter={() => setHovered('todo')}
        onMouseLeave={() => setHovered(null)}
      >
        <Tooltip text="TODO リスト" visible={hovered === 'todo'} position="right" />
        <Icon name="todo" size={24} />
      </button>

      <button
        className={`app-nav-button ${activeItem === 'stock' ? 'active' : ''}`}
        aria-label="ストック"
        onClick={goStock}
        onMouseEnter={() => setHovered('stock')}
        onMouseLeave={() => setHovered(null)}
      >
        <Tooltip text="ストック" visible={hovered === 'stock'} position="right" />
        <Icon name="shop" size={24} />
      </button>
    </nav>
  );
};

export default AppNav;
